import { Button, Space, Tag, Typography } from "antd";

const { Text } = Typography;

export default function SeletorDeFiliais({ value, onChange, filiais }) {
  const escolhidas = value || [];
  const marcadas = new Set(escolhidas);

  if (!filiais.length) {
    return <Text type="secondary">Escolha o cliente para ver as filiais.</Text>;
  }

  const alternar = (id, marcar) =>
    onChange(
      marcar
        ? [...escolhidas, id]
        : escolhidas.filter((escolhida) => escolhida !== id)
    );

  return (
    <div>
      <Space size={[8, 8]} wrap>
        {filiais.map((filial) => (
          <Tag.CheckableTag
            key={filial.value}
            checked={marcadas.has(filial.value)}
            onChange={(marcar) => alternar(filial.value, marcar)}
            style={{
              margin: 0,
              padding: "4px 14px",
              fontSize: 14,
              borderRadius: 16,
              border: `1px solid ${marcadas.has(filial.value) ? "#1677ff" : "#d9d9d9"}`,
            }}>
            {filial.nome}
          </Tag.CheckableTag>
        ))}
      </Space>
      <Space size={0} style={{ display: "flex", marginTop: 8 }}>
        <Text type="secondary">
          {escolhidas.length
            ? `${escolhidas.length} de ${filiais.length} escolhidas`
            : "Nenhuma filial escolhida"}
        </Text>
        <Button
          type="link"
          size="small"
          disabled={escolhidas.length === filiais.length}
          onClick={() => onChange(filiais.map((f) => f.value))}>
          Marcar todas
        </Button>
        <Button
          type="link"
          size="small"
          disabled={!escolhidas.length}
          onClick={() => onChange([])}>
          Limpar
        </Button>
      </Space>
    </div>
  );
}
